import React from 'react';
import { Calendar, MapPin, Building, Activity } from 'lucide-react';
import type { Database } from '../../types/supabase';

type Animatronic = Database['public']['Tables']['animatronics']['Row'] & {
  supplier?: Database['public']['Tables']['suppliers']['Row'];
};

interface AnimatronicInfoProps {
  animatronic: Animatronic;
}

const AnimatronicInfo: React.FC<AnimatronicInfoProps> = ({ animatronic }) => {
  const details = [
    { icon: MapPin, value: animatronic.country },
    { icon: Building, value: animatronic.park },
    { icon: Calendar, value: animatronic.year },
    { icon: Activity, value: animatronic.status },
  ];

  return (
    <div className="flex flex-wrap items-start justify-between gap-4 mb-6">
      <div>
        <h1 className="text-3xl font-bold text-content-primary mb-2">{animatronic.name}</h1>
        <div className="flex flex-wrap gap-4 text-sm text-content-secondary">
          {details.map((detail, index) => (
            <div key={index} className="flex items-center">
              <detail.icon className="w-4 h-4 mr-1 text-brand" />
              <span className="capitalize">{detail.value}</span>
            </div>
          ))}
        </div>
      </div>
      
      <div className="flex items-center">
        <span className="inline-flex items-center px-3 py-1 rounded-full text-sm font-medium bg-brand/20 text-brand">
          {animatronic.type}
        </span>
      </div>
    </div>
  );
};

export default AnimatronicInfo;